'use strict';

module.exports = {
    SIGN: 'Увійти',
    SIGN_JOIN: 'SУвійдіть або зареєструйтеся безкоштовно!',
    EMAIL_EXISTS: 'Ця електронна адреса вже існує',
    INVALID_EMAIL: 'Введіть дійсну електронну адресу',
    INVALID_FIRST_NAME: 'Введіть дійсне ім’я',
    INVALID_LAST_NAME: 'Введіть дійсне прізвище',
    INVALID_PASSWORD: ' Введіть 6–20 символів (тільки A–Z, a–z, 0–9)',
    INVALID_REPASSWORD: 'Паролі не збігаються',
    INVALID_VALID_CODE: 'Введіть дійсний код',
    UNAVIALABLE_SERVICE: 'Служба недоступна, спробуйте пізніше',
    EMPTY_VALID_CODE: 'Введіть символи, які ви бачите на зображенні',
    NOT_MEMBER: 'Не учасник?',
    ALREADY_MEMBER: 'Учасник AliExpress/Alibaba?',
    EMAIL: 'Електронна адреса',
    CONTACT_NAME: 'Контактне ім’я:',
    FIRST_NAME: 'Ім’я',
    LAST_NAME: 'Прізвище',
    PASSWORD: 'Пароль',
    REPASSWORD: ' Введіть пароль ще раз:',
    EMPTY_CODE: 'Введіть наведений код:',
    REFRESH: 'Оновити',
    CREATE_MY_ACCOUNT: 'Створити обліковий запис',
    NAME: 'Ім’я',
    VERIFICATION: 'Код підтвердження',
    AGREE_MENT: 'Створюючи обліковий запис, ви погоджуєтеся з',
    AE_MEMBER_SHIP: 'Безкоштовною угодою учасника AliExpress.com',
    AND: 'та',
    PRIVACY_POLICY: 'Політикою конфіденційності',
    SLIDE_SUBMIT: 'ПРОВЕДІТЬ ПРАВОРУЧ, ЩОБ ПІДТВЕРДИТИ',
    SLIDE_SUBMIT_TIPS: 'Успішно',
    LOADING: 'Завантаження ...',
    SLIDE_SUBMIT_ERROR_TIPS: 'Проведіть праворуч, щоб підтвердити',
    SHOP_NOW: 'Купити зараз',
    SIGN_IN: 'Увійти',
    REGISTER_SMS: 'Зареєструватися через СМС',
    REGISTER_EMAIL: 'Зареєструватися через ел',
    PHONE_NUMBER: 'Номер телефону',
    VALID_NUMBER: 'Введіть дійсний номер телефону.',
    SEND_SMS_CODE: 'Надіслати СМС-код',
    SMS_POLICY: 'Ми надішлемо код перевірки через СМС на номер телефону, який ви ввели. Переконайтеся, що код країни та номер телефону правильні.',
    SEND_TO: 'Ми надіслали код на',
    VERIFICATION_RECEIVED: 'Введіть отриманий код підтвердження або',
    EDIT_NUMBER: 'відредагуйте номер.',
    RESEND_CODE: 'Надіслати код повторно',
    LAST_STEP: 'Останній крок',
    SET_SIGN_IN_PASSWORD: 'Створіть пароль для входу, щоб захистити свій обліковий запис.',
    INVALID_PHONE_PASSWORD: '6–20 символів (тільки літери та цифри)',
    NOT_CORRECT_CODE: 'Код неправильний, спробуйте ще.',
    SAVE_PASSWORD: 'Зберегти пароль',
    NO_RECEIVED_CODE: 'Якщо ви досі не отримали код, спробуйте',
    VIA_EMAIL: 'Зареєструватися через ел. адресу'
};